import React from 'react';
import ClassNames from 'classnames';

import Router from 'react-router-component';

function isLeftClickEvent(event) {
	return event.button === 0;
}

function isModifiedEvent(event) {
	return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

export default {

	propTypes: {
		href: React.PropTypes.string.isRequired,
		activeClassName: React.PropTypes.string,
		params: React.PropTypes.object,
		query: React.PropTypes.object,
		onClick: React.PropTypes.func
	},

	mixins: [ Router.NavigatableMixin ],

	getDefaultProps () {
		return {
			activeClassName: 'lui-is-active'
		};
	},

	isActive() {
		return this.getPath() === this.props.href;
	}

};



/** WEBPACK FOOTER **
 ** ./src/mixins/js/LinkMixin.js
 **/